
import DataTable from 'react-data-table-component';
import Modal from 'react-bootstrap/Modal';
import { useEffect, useMemo, useRef, useState } from 'react';
import { fetchData, fetchFormData, toasterrormsg, toastsuccessmsg } from '../../../reusable';
import Swal from 'sweetalert2'
import 'react-phone-input-2/lib/style.css'
import 'react-phone-input-2/lib/bootstrap.css'
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';

function LoyaltiProgramPage() {

  const [adminData,setAdminData]= useState(Object)
  const [bookingList,setBookingList]=useState([{loyaltysettingId:"",point:"",availability:"",amount:"",compare:""}])
  const [reviewsList,setReviewsList]=useState([])
  const [explorePostList,setExplorePostList]=useState([])
  const [bonusList,setBonusList]=useState([])
  
  useEffect(()=>{
    document.title = 'Insayr | Loyalty Program' 
    var store:any=sessionStorage.getItem("admin");
    setAdminData(JSON.parse(store))
    

  },[])

  const addbookingrow=async()=>{
    var tmp:any=[...bookingList,{id:"",point:0,availability:0,amount:0,equal:"Grater Than Equal to"}];
    setBookingList(tmp)
    
  }
  const removebookingrow=async(index:any)=>{
    var tmp:any=bookingList.filter((item:any,ind:any)=>ind!=index)    
    setBookingList(tmp)
    
  }

  const onchange=(column:any,value:any,index:any)=>{
    var tmp:any=[...bookingList]
    tmp[index][column]=value
    setBookingList(tmp)
  }


  // call API start
  const selectLoyaltySettingAPICall=async()=>{
    var param={}
    var res=await fetchData("admin/selectLoyaltySetting",param)
    if(res.status==200)
    {
      var tmp=res.data.filter((item:any)=>item.type=="Reviews").map((item:any)=>{return {loyaltysettingId:item.loyaltysettingId,point:item.point,amount:item.amount,availability:item.availability,label:item.label}})
      setReviewsList(tmp)

      var tmp=res.data.filter((item:any)=>item.type=="Explore Posts").map((item:any)=>{return {loyaltysettingId:item.loyaltysettingId,point:item.point,amount:item.amount,availability:item.availability,label:item.label}})
      setExplorePostList(tmp)

      var tmp=res.data.filter((item:any)=>item.type=="Booking").map((item:any)=>{return {loyaltysettingId:item.loyaltysettingId,point:item.point,amount:item.amount,availability:item.availability,label:item.label,compare:item.compare}})
      setBookingList(tmp)

      var tmp=res.data.filter((item:any)=>item.type=="Bonus").map((item:any)=>{return {loyaltysettingId:item.loyaltysettingId,point:item.point,amount:item.amount,availability:item.availability,label:item.label,compare:item.compare}})
      setBonusList(tmp)


    }
    else
    {
      toasterrormsg(res.message)
    }
  }

  const onSubmit=async(type:any)=>{
    var param:any={
      adminId:adminData['adminId']
    }
    var API="admin/addUpdateBooking"

    if(type=="booking")
    {
      param['type']="Booking"
      param['response']=bookingList
    }
    else if(type=="review")
    {
      param['response']=reviewsList
      API="admin/updateReviewReward"
    }
    else if(type=="post")
    {
      param['response']=explorePostList
      API="admin/updateReviewReward"
    }
      var res=await fetchData(API,param)
      if(res.status==200)
      {
        if(type=="booking")
        {
          param['type']="Bonus"
          param['response']=bonusList
          var res=await fetchData(API,param)
          if(res.status==200)
          {

            toastsuccessmsg("Success")
          }
          else
          {
            toasterrormsg(res.message)
          }
        }
        else
        {
          toastsuccessmsg("Success")
        }
      }
      else
      {
        toasterrormsg(res.message)
      }
    }



  useEffect(()=>{
    selectLoyaltySettingAPICall()
  },[])

  return (<>
  <ToastContainer />
    <div className="container">

      <div className="row mt-5">
        {/* Booking section start */}
        <div className="col-12">
          <label className='h3'>Booking</label>
        </div>
        {/* Booking section end */}

        <table className="table">
          <thead>
            <tr>
              <th scope="col"></th>
              <th scope="col" className='fs-4 fw-bold'>Points</th>
              <th scope="col" className='fs-4 fw-bold'>Availability</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {bookingList.map((item:any,index:any)=>{
              return(
                <>
                <tr>
                  <td><label className='d-inline-block'><span className='fs-4 fw-bold d-inline-block'>For every $ </span><input type='text' className='form-control form-control-solid d-inline-block mw-80px' placeholder='Amount' value={item.amount} onChange={(e:any)=>{if(e.target.value.match(/^\d+$/) || e.target.value==""){onchange("amount",e.target.value.replace(/^0+(?=\d)/, '') || 0,index)}}} /><span className='fs-4 fw-bold d-inline-block'> or </span> <select className='form-select form-select-solid d-inline-block mw-150px' defaultChecked={item.compare} value={item.compare} onChange={(e:any)=>{onchange("compare",e.target.value,index)}}><option value={"Grater Than Equal to"}>Grater Than Equal to</option><option value={"Equal to"}>Equal to</option></select></label></td>
                  <td><input type='text' className='form-control form-control-solid' placeholder='Enter Point' value={item.point} onChange={(e:any)=>{if(e.target.value.match(/^\d+$/) || e.target.value==""){onchange("point",e.target.value.replace(/^0+(?=\d)/, '') || 0,index)}}} /></td>
                  <td><input type='text' className='form-control form-control-solid' placeholder='Enter Availability' value={item.availability} onChange={(e:any)=>{if(e.target.value.match(/^\d+$/) || e.target.value==""){onchange("availability",e.target.value.replace(/^0+(?=\d)/, '') || 0,index)}}} /></td>
                  <td>{index>0 && <button className='btn btn-danger' onClick={()=>{removebookingrow(index)}}><FontAwesomeIcon icon={faMinus} /></button>}</td>
                </tr>
                
                </>
              )
            })}
            
            
            <tr>
              <td colSpan={3}></td>
              <td>
                <button className='btn btn-success' onClick={()=>{addbookingrow()}}><FontAwesomeIcon icon={faPlus} /></button>
              </td>
            </tr>
            <tr>
                  <td><label className='d-inline-block'><span className='fs-4 fw-bold d-inline-block'>Gold level members earn</span><input type='text' className='form-control form-control-solid d-inline-block mw-80px' placeholder='Amount' value={bonusList.length>0? bonusList[0]['amount'] :0} onChange={(e:any)=>{if((e.target.value.match(/^\d+$/) || e.target.value=="" )&& e.target.value <=100){var tmp:any=[...bonusList];tmp[0]['amount']=e.target.value.replace(/^0+(?=\d)/, '') || 0;setBonusList(tmp)}}} /><span className='fs-4 fw-bold d-inline-block'>% more Points. </span> </label></td>
                  
                </tr>
                <tr>
                  <td><label className='d-inline-block'><span className='fs-4 fw-bold d-inline-block'>Platinum level members earn</span><input type='text' className='form-control form-control-solid d-inline-block mw-80px' placeholder='Amount' value={bonusList.length>0? bonusList[1]['amount'] :0} onChange={(e:any)=>{if((e.target.value.match(/^\d+$/) || e.target.value=="" )&& e.target.value <=100){var tmp:any=[...bonusList];tmp[1]['amount']=e.target.value.replace(/^0+(?=\d)/, '') || 0;setBonusList(tmp)}}} /><span className='fs-4 fw-bold d-inline-block'>% more Points. </span> </label></td>
                  
                </tr>
                <tr>
                  <td><label className='d-inline-block'><span className='fs-4 fw-bold d-inline-block'>Diamond level members earn</span><input type='text' className='form-control form-control-solid d-inline-block mw-80px' placeholder='Amount' value={bonusList.length>0? bonusList[2]['amount'] :0} onChange={(e:any)=>{if((e.target.value.match(/^\d+$/) || e.target.value=="" )&& e.target.value<=100){var tmp:any=[...bonusList];tmp[2]['amount']=e.target.value.replace(/^0+(?=\d)/, '') || 0;setBonusList(tmp)}}} /><span className='fs-4 fw-bold d-inline-block'>% more Points. </span> </label></td>
                
                </tr>
            <tr>
              <td colSpan={4} style={{textAlign:"right"}}>
                <button className='btn btn-success' onClick={()=>{onSubmit("booking")}}>Save</button>
              </td>
            </tr>
            
          </tbody>
        </table>

        <hr />

        {/* Reviews section start */}
        <div className="col-12">
          <label className='h3'>Reviews</label>
          <table className="table">
            <thead>
              <tr>
                <th scope="col"></th>
                <th scope="col" className='fs-4 fw-bold'>Points</th>
                <th scope="col" className='fs-4 fw-bold'>Availability</th>
              </tr>
            </thead>
            <tbody>
            
              <tr>
                <th scope="row" ><p className='fs-5 fw-bold'>Under 20 characters</p></th>
                <td><input type='text' className='form-control form-control-solid' placeholder='Enter Point' value={reviewsList.length>0? reviewsList[0]['point'] :0} onChange={(e:any)=>{if(e.target.value.match(/^\d+$/) || e.target.value==""){var tmp:any=[...reviewsList];tmp[0]['point']=e.target.value.replace(/^0+(?=\d)/, '') || 0;setReviewsList(tmp)}}}  /></td>
                <td><input type='text' className='form-control form-control-solid' placeholder='Enter Availability' value={reviewsList.length>0? reviewsList[0]['availability'] :0} onChange={(e:any)=>{if(e.target.value.match(/^\d+$/) || e.target.value==""){var tmp:any=[...reviewsList];tmp[0]['availability']=e.target.value.replace(/^0+(?=\d)/, '') || 0;setReviewsList(tmp)}}}  /></td>
              </tr>
              <tr>
                 <th scope="row" ><p className='fs-5 fw-bold'>20-50 characters</p></th>
                <td><input type='text' className='form-control form-control-solid' placeholder='Enter Point' value={reviewsList.length>0? reviewsList[1]['point'] :0} onChange={(e:any)=>{if(e.target.value.match(/^\d+$/) || e.target.value==""){var tmp:any=[...reviewsList];tmp[1]['point']=e.target.value.replace(/^0+(?=\d)/, '') || 0;setReviewsList(tmp)}}}  /></td>
                <td><input type='text' className='form-control form-control-solid' placeholder='Enter Availability' value={reviewsList.length>0? reviewsList[1]['availability'] :0} onChange={(e:any)=>{if(e.target.value.match(/^\d+$/) || e.target.value==""){var tmp:any=[...reviewsList];tmp[1]['availability']=e.target.value.replace(/^0+(?=\d)/, '') || 0;setReviewsList(tmp)}}}  /></td>
              </tr>
              <tr>
                 <th scope="row" ><p className='fs-5 fw-bold'>Over 50 characters</p></th>
                <td><input type='text' className='form-control form-control-solid' placeholder='Enter Point' value={reviewsList.length>0? reviewsList[2]['point'] :0} onChange={(e:any)=>{if(e.target.value.match(/^\d+$/) || e.target.value==""){var tmp:any=[...reviewsList];tmp[2]['point']=e.target.value.replace(/^0+(?=\d)/, '') || 0;setReviewsList(tmp)}}}  /></td>
                <td><input type='text' className='form-control form-control-solid' placeholder='Enter Availability' value={reviewsList.length>0? reviewsList[2]['availability'] :0} onChange={(e:any)=>{if(e.target.value.match(/^\d+$/) || e.target.value==""){var tmp:any=[...reviewsList];tmp[2]['availability']=e.target.value.replace(/^0+(?=\d)/, '') || 0;setReviewsList(tmp)}}}  /></td>
              </tr>
              <tr>
                <th scope="row" ><p className='fs-5 fw-bold'>Upload an image or video</p></th>
                <td><input type='text' className='form-control form-control-solid' placeholder='Enter Point' value={reviewsList.length>0? reviewsList[3]['point'] :0} onChange={(e:any)=>{if(e.target.value.match(/^\d+$/) || e.target.value==""){var tmp:any=[...reviewsList];tmp[3]['point']=e.target.value.replace(/^0+(?=\d)/, '') || 0;setReviewsList(tmp)}} } /></td>
                <td><input type='text' className='form-control form-control-solid' placeholder='Enter Availability' value={reviewsList.length>0? reviewsList[3]['availability'] :0} onChange={(e:any)=>{if(e.target.value.match(/^\d+$/) || e.target.value==""){var tmp:any=[...reviewsList];tmp[3]['availability']=e.target.value.replace(/^0+(?=\d)/, '') || 0;setReviewsList(tmp)}}}  /></td>
              </tr>
              <tr>
                <td colSpan={3} style={{textAlign:"right"}}>
                  <button className='btn btn-success' onClick={()=>onSubmit("review")}>Save</button>
                </td>
              </tr>
              
            </tbody>
          </table>
          
         
        </div>
        {/* Reviews section end */}

        <hr />

        {/* Explore Posts section start */}
        <div className="col-12">
          <label className='h3'>Explore Posts</label>
          <table className="table">
            <thead>
              <tr>
                <th scope="col"></th>
                <th scope="col" className='fs-4 fw-bold'>Points</th>
                <th scope="col" className='fs-4 fw-bold'>Availability</th>
              </tr>
            </thead>
            <tbody>
             
              <tr>
                <th scope="row" >
                  <label className='fs-5'>
                    <label className='fs-4 fw-bold'>Level 1 - Rookie:</label><br/>
                    <label className='fs-5'>Like 2 posts</label><br/>
                    <label className='fs-5'>Follow 2 Friends</label><br/>
                    <label className='fs-5'>Comment on 2 posts</label><br/>
                    <label className='fs-5'>Complete Profile details</label>
                  </label>
                </th>
                <td><input type='text' className='form-control form-control-solid' placeholder='Enter Point' value={explorePostList.length>0?explorePostList[0]['point'] :0} onChange={(e:any)=>{if(e.target.value.match(/^\d+$/) || e.target.value==""){var tmp:any=[...explorePostList];tmp[0]['point']=e.target.value.replace(/^0+(?=\d)/, '') || 0;setExplorePostList(tmp)}}} /></td>
                <td><input type='text' className='form-control form-control-solid' placeholder='Enter Availability' value={explorePostList.length>0?explorePostList[0]['availability'] :0} onChange={(e:any)=>{if(e.target.value.match(/^\d+$/) || e.target.value==""){var tmp:any=[...explorePostList];tmp[0]['availability']=e.target.value.replace(/^0+(?=\d)/, '') || 0;setExplorePostList(tmp)}}} /></td>
              </tr>
              <tr>
                <th scope="row" >
                  <label className='fs-5'>
                    <label className='fs-4 fw-bold'>Level 2 – Contributor:</label><br/>
                    <label className='fs-5'>Successfully post 1 Trip Moment</label>
                  </label>
                </th>
                <td><input type='text' className='form-control form-control-solid' placeholder='Enter Point' value={explorePostList.length>0?explorePostList[1]['point'] :0} onChange={(e:any)=>{if(e.target.value.match(/^\d+$/) || e.target.value==""){var tmp:any=[...explorePostList];tmp[1]['point']=e.target.value.replace(/^0+(?=\d)/, '') || 0;setExplorePostList(tmp)}}} /></td>
                <td><input type='text' className='form-control form-control-solid' placeholder='Enter Availability' value={explorePostList.length>0?explorePostList[1]['availability'] :0} onChange={(e:any)=>{if(e.target.value.match(/^\d+$/) || e.target.value==""){var tmp:any=[...explorePostList];tmp[1]['availability']=e.target.value.replace(/^0+(?=\d)/, '') || 0;setExplorePostList(tmp)}}} /></td>
              </tr>
              <tr>
                <th scope="row" className='fs-5'>
                  <label className='fs-5'>
                    <label className='fs-4 fw-bold'>Level 3 – Explorer:</label><br/>
                    <label className='fs-5'>Successfully post 2 "featured" Trip Moments</label>
                </label>
                </th>
                <td><input type='text' className='form-control form-control-solid' placeholder='Enter Point' value={explorePostList.length>0?explorePostList[2]['point'] :0} onChange={(e:any)=>{if(e.target.value.match(/^\d+$/) || e.target.value==""){var tmp:any=[...explorePostList];tmp[2]['point']=e.target.value.replace(/^0+(?=\d)/, '') || 0;setExplorePostList(tmp)}}} /></td>
                <td><input type='text' className='form-control form-control-solid' placeholder='Enter Availability' value={explorePostList.length>0?explorePostList[2]['availability'] :0} onChange={(e:any)=>{if(e.target.value.match(/^\d+$/) || e.target.value==""){var tmp:any=[...explorePostList];tmp[2]['availability']=e.target.value.replace(/^0+(?=\d)/, '') || 0;setExplorePostList(tmp)}}} /></td>
              </tr>
              <tr>
                <th scope="row" className='fs-5'>
                  <label className='fs-5'>
                    <label className='fs-4 fw-bold'>Level 4 – Rising Star:</label><br/>
                    <label className='fs-5'>Successfully post 5 "featured" Trip Moments</label>
                  </label>
                </th>
                <td><input type='text' className='form-control form-control-solid' placeholder='Enter Point' value={explorePostList.length>0?explorePostList[3]['point'] :0} onChange={(e:any)=>{if(e.target.value.match(/^\d+$/) || e.target.value==""){var tmp:any=[...explorePostList];tmp[3]['point']=e.target.value.replace(/^0+(?=\d)/, '') || 0;setExplorePostList(tmp)}}} /></td>
                <td><input type='text' className='form-control form-control-solid' placeholder='Enter Availability' value={explorePostList.length>0?explorePostList[3]['availability'] :0} onChange={(e:any)=>{if(e.target.value.match(/^\d+$/) || e.target.value==""){var tmp:any=[...explorePostList];tmp[3]['availability']=e.target.value.replace(/^0+(?=\d)/, '') || 0;setExplorePostList(tmp)}}} /></td>
              </tr>
              <tr>
                <th scope="row" className='fs-5'>
                  <label className='fs-5'>
                    <label className='fs-4 fw-bold'>Level 5 – Pioneer:</label><br/>
                    <label className='fs-5'>Successfully post 15 "featured" Trip Moments</label>
                  </label>
                </th>
                <td><input type='text' className='form-control form-control-solid' placeholder='Enter Point' value={explorePostList.length>0?explorePostList[4]['point'] :0} onChange={(e:any)=>{if(e.target.value.match(/^\d+$/) || e.target.value==""){var tmp:any=[...explorePostList];tmp[4]['point']=e.target.value.replace(/^0+(?=\d)/, '') || 0;setExplorePostList(tmp)}}} /></td>
                <td><input type='text' className='form-control form-control-solid' placeholder='Enter Availability' value={explorePostList.length>0?explorePostList[4]['availability'] :0} onChange={(e:any)=>{if(e.target.value.match(/^\d+$/) || e.target.value==""){var tmp:any=[...explorePostList];tmp[4]['availability']=e.target.value.replace(/^0+(?=\d)/, '') || 0;setExplorePostList(tmp)}}} /></td>
              </tr>
              <tr>
                <th scope="row" className='fs-5'>
                  <label className='fs-5'>
                    <label className='fs-4 fw-bold'>Level 6 – Expert:</label><br/>
                    <label className='fs-5'>Successfully post 40 "featured" Trip Moments</label>
                  </label>
                </th>
                <td><input type='text' className='form-control form-control-solid' placeholder='Enter Point' value={explorePostList.length>0?explorePostList[5]['point'] :0} onChange={(e:any)=>{if(e.target.value.match(/^\d+$/) || e.target.value==""){var tmp:any=[...explorePostList];tmp[5]['point']=e.target.value.replace(/^0+(?=\d)/, '') || 0;setExplorePostList(tmp)}}} /></td>
                <td><input type='text' className='form-control form-control-solid' placeholder='Enter Availability' value={explorePostList.length>0?explorePostList[5]['availability'] :0} onChange={(e:any)=>{if(e.target.value.match(/^\d+$/) || e.target.value==""){var tmp:any=[...explorePostList];tmp[5]['availability']=e.target.value.replace(/^0+(?=\d)/, '') || 0;setExplorePostList(tmp)}}} /></td>
              </tr>
              <tr>
                <th scope="row" className='fs-5'>
                  <label className='fs-5'>
                    <label className='fs-4 fw-bold'>Level 7 – Expert Pro:</label><br/>
                    <label className='fs-5'>Successfully post 80 "featured" Trip Moments</label>
                  </label>
                </th>
                <td><input type='text' className='form-control form-control-solid' placeholder='Enter Point' value={explorePostList.length>0?explorePostList[6]['point'] :0} onChange={(e:any)=>{if(e.target.value.match(/^\d+$/) || e.target.value==""){var tmp:any=[...explorePostList];tmp[6]['point']=e.target.value.replace(/^0+(?=\d)/, '') || 0;setExplorePostList(tmp)}}} /></td>
                <td><input type='text' className='form-control form-control-solid' placeholder='Enter Availability' value={explorePostList.length>0?explorePostList[6]['availability'] :0} onChange={(e:any)=>{if(e.target.value.match(/^\d+$/) || e.target.value==""){var tmp:any=[...explorePostList];tmp[6]['availability']=e.target.value.replace(/^0+(?=\d)/, '') || 0;setExplorePostList(tmp)}}} /></td>
              </tr>
              <tr>
                <th scope="row" className='fs-5'>
                  <label className='fs-5'>
                    <label className='fs-4 fw-bold'>Level 8 – Master:</label><br/>
                    <label className='fs-5'>Successfully post 200 "featured" Trip Moments</label>
                  </label>
                </th>
                <td><input type='text' className='form-control form-control-solid' placeholder='Enter Point' value={explorePostList.length>0?explorePostList[7]['point'] :0} onChange={(e:any)=>{if(e.target.value.match(/^\d+$/) || e.target.value==""){var tmp:any=[...explorePostList];tmp[7]['point']=e.target.value.replace(/^0+(?=\d)/, '') || 0;setExplorePostList(tmp)}}} /></td>
                <td><input type='text' className='form-control form-control-solid' placeholder='Enter Availability' value={explorePostList.length>0?explorePostList[7]['availability'] :0} onChange={(e:any)=>{if(e.target.value.match(/^\d+$/) || e.target.value==""){var tmp:any=[...explorePostList];tmp[7]['availability']=e.target.value.replace(/^0+(?=\d)/, '') || 0;setExplorePostList(tmp)}}} /></td>
              </tr>
              <tr>
                <th scope="row" className='fs-5'>
                <label className='fs-5'>
                    <label className='fs-4 fw-bold'>Level 9 – Master Pro:</label><br/>
                    <label className='fs-5'>Successfully post 400 "featured" Trip Moments</label>
                  </label>
                </th>
                <td><input type='text' className='form-control form-control-solid' placeholder='Enter Point' value={explorePostList.length>0?explorePostList[8]['point'] : 0} onChange={(e:any)=>{if(e.target.value.match(/^\d+$/) || e.target.value==""){var tmp:any=[...explorePostList];tmp[8]['point']=e.target.value.replace(/^0+(?=\d)/, '') || 0;setExplorePostList(tmp)}}} /></td>
                <td><input type='text' className='form-control form-control-solid' placeholder='Enter Availability' value={explorePostList.length>0?explorePostList[8]['availability'] : 0} onChange={(e:any)=>{if(e.target.value.match(/^\d+$/) || e.target.value==""){var tmp:any=[...explorePostList];tmp[8]['availability']=e.target.value.replace(/^0+(?=\d)/, '') || 0;setExplorePostList(tmp)}}} /></td>
              </tr>
              <tr>
                <th scope="row" className='fs-5'>
                  <label className='fs-5'>
                    <label className='fs-4 fw-bold'>Level 10 – Ambassador:</label><br/>
                    <label className='fs-5'>Successfully post 800 "featured" Trip Moments</label>
                  </label>
                </th>
                <td><input type='text' className='form-control form-control-solid' placeholder='Enter Point' value={explorePostList.length>0?explorePostList[9]['point'] : 0} onChange={(e:any)=>{if(e.target.value.match(/^\d+$/) || e.target.value==""){var tmp:any=[...explorePostList];tmp[9]['point']=e.target.value.replace(/^0+(?=\d)/, '') || 0;setExplorePostList(tmp)}}} /></td>
                <td><input type='text' className='form-control form-control-solid' placeholder='Enter Availability' value={explorePostList.length>0?explorePostList[9]['availability'] :0} onChange={(e:any)=>{if(e.target.value.match(/^\d+$/) || e.target.value==""){var tmp:any=[...explorePostList];tmp[9]['availability']=e.target.value.replace(/^0+(?=\d)/, '') || 0;setExplorePostList(tmp)}}} /></td>
              </tr>
              <tr>
                <td colSpan={3} style={{textAlign:"right"}}>
                  <button className='btn btn-success' onClick={()=>onSubmit("post")}>Save</button>
                </td>
              </tr>
            </tbody>
          </table>

        </div>
        {/* Explore Posts section end */}
      </div>
      
    </div>

    </>
  );
}

export default LoyaltiProgramPage;



